import React, { useRef, useState } from 'react';

import { ReactComponent as DownArrow } from '../../assets/icons/down-arrow.svg';

/**
 * Custom drop down component
 * @returns
 */
function CustomDropDown({
  icon,
  arrowPosition,
  backgroundColor,
  label,
  content,
  open,
  count,
  height,
  title,
  description,
}: {
  icon?: JSX.Element;
  arrowPosition?: 'left' | 'right';
  backgroundColor?: 'primary' | 'plain';
  label?: string;
  content: JSX.Element | null;
  open?: boolean;
  count?: number;
  height?: number;
  title?: string;
  description?: string;
}) {
  const [isOpen, setIsOpen] = useState(open);
  const contentReference = useRef<HTMLDivElement>(null);
  return (
    <div className={`custom-drop-down-wrap ${backgroundColor}`}>
      <div
        className={`custom-drop-down-container ${backgroundColor}`}
        style={{ height: height && `${height}px` }}
        onClick={() => setIsOpen((previous) => !previous)}
        role="presentation">
        {icon && icon}
        {arrowPosition === 'left' && (
          <div className={`custom-drop-down-arrow ${isOpen ? 'rotate' : ''}`}>
            <DownArrow />
          </div>
        )}
        <div className="custom-drop-down-label">
          {label && (
            <p className="label">
              {label} {count !== null && <span className="counts">{count}</span>}
            </p>
          )}
          {title && description && (
            <div className="title-and-description">
              <p className="title">{title}</p>
              <p className="description">{description}</p>
            </div>
          )}
          {arrowPosition === 'right' && (
            <div className={`custom-drop-down-arrow ${isOpen ? 'rotate' : ''}`}>
              <DownArrow />
            </div>
          )}
        </div>
      </div>
      <div
        className={`custom-drop-down-content ${isOpen ? 'open' : ''}`}
        style={{ maxHeight: isOpen ? contentReference.current?.scrollHeight : 0 }}
        ref={contentReference}>
        <div className="inner-content">{content}</div>
      </div>
    </div>
  );
}

export default CustomDropDown;

CustomDropDown.defaultProps = {
  icon: null,
  open: false,
  arrowPosition: 'left',
  backgroundColor: 'primary',
  count: null,
  height: 35,
  label: '',
  title: '',
  description: '',
};
